import ContactData from './ContactData';

export default ContactData;
